import Box from '@mui/material/Box'

import I18n from 'common/i18n'

import { LogoInterface, LogoLayout, LogoTone, LogoTypeEnum } from './interfaces'

const BRAND_PATH = '/assets/brand'

export function brandLogoSrc(layout: LogoLayout, tone: LogoTone): string {
  const name = layout === 'simbolo' ? 'simbolo' : `logo-${layout}`
  return `${BRAND_PATH}/${name}-${tone}.svg`
}

const LEGACY_TONE: Record<LogoTypeEnum, LogoTone> = {
  [LogoTypeEnum.DARK]: 'cor',
  [LogoTypeEnum.LIGHT]: 'negativo'
}

const DEFAULT_HEIGHT: Record<LogoLayout, number> = {
  horizontal: 40,
  vertical: 96,
  simbolo: 32
}

const Logo = (props: LogoInterface) => {
  const layout = props.layout ?? 'horizontal'
  const tone = props.tone ?? (props.type ? LEGACY_TONE[props.type] : 'cor')
  const height = props.height ?? DEFAULT_HEIGHT[layout]

  return (
    <Box
      component='img'
      src={brandLogoSrc(layout, tone)}
      alt={props.alt ?? I18n.general.logo}
      onClick={props.rauter}
      sx={[
        {
          display: 'block',
          height,
          width: 'auto',
          maxWidth: '100%',
          cursor: props.rauter ? 'pointer' : 'inherit'
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx])
      ]}
    />
  )
}

export default Logo
